import * as THREE from 'three';
import Action from '../classes/Action';
import {GroupsManager} from '../classes/GroupsManager';
import DefaultSceneManager from '../classes/DefaultSceneManager';
import Scenario from '../classes/scenarioElements/Scenario';
import { CustomEventTypes } from '../globals';
import { assert } from '../classes/utilities/ErrorHandling';

export default class AddToGroupAction extends Action
{
	constructor(groupGuid: string, objects: THREE.Object3D[])
	{
		const group = GroupsManager.getGroupByGuid(groupGuid);
		assert(group, "Group not found with id " + groupGuid);
		if(!group) throw new Error("Group not found with id " + groupGuid); // not actually necessary, but typescript doesn't know that assert throws an error

		const groupName = group.name;
		const actionName = objects.length === 1 ? "Added " + objects[0].name + " To Group " + groupName : "Added Objects To Group " + groupName;
		const isDefaultState = Scenario.currentStep()?.isDefault();

		super([groupGuid, objects, isDefaultState],
			[groupGuid, objects, isDefaultState],
			actionName,
			[groupGuid, objects]);
	}

	do(groupGuid: string, objects: THREE.Object3D[], isDefaultState: boolean)
	{
		if (isDefaultState)	DefaultSceneManager.getInstance().syncGroupChange(objects, groupGuid, true);

		GroupsManager.addToGroup(groupGuid, objects);
		document.dispatchEvent(new CustomEvent(CustomEventTypes.updatePropertiesComponent));
	}

	undo(groupGuid: string, objects: THREE.Object3D[], isDefaultState: boolean)
	{
		if (isDefaultState)	DefaultSceneManager.getInstance().syncGroupChange(objects, groupGuid, false);

		GroupsManager.removeFromGroup(groupGuid, objects);
		document.dispatchEvent(new CustomEvent(CustomEventTypes.updatePropertiesComponent));
	}

	verify(groupGuid: string, objects: any[])
	{
		assert(GroupsManager.getGroupByGuid(groupGuid));

		const groupObjects = GroupsManager.getGroupObjects(groupGuid);
		for (const object of objects)
		{
			if (!groupObjects.includes(object)) return true;
		}

		return false;
	}
}